var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#50C878",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3996 3886 c-100 -60 -98 -204 4 -256 37 -19 58 -20 322 -20 l283 0 -942 -942 -943 -943 -552 552 c-304 303 -567 558 -585 567 -41 20 -86 20 -126 0 -47 -25 -1427 -1392 -1443 -1431 -53 -125 73 -244 199 -189 18 8 281 260 602 576 314 310 600 593 638 629 l67 66 553 -552 c303 -303 566 -558 584 -567 41 -20 85 -20 126 0 18 9 483 467 1035 1017 l1002 1002 0 -283 c0 -258 2 -286 19 -320 22 -43 84 -82 130 -82 51 0 108 35 131 80 19 38 20 58 20 520 0 462 -1 482 -20 520 -13 26 -34 47 -60 60 -38 19 -58 20 -522 20 l-483 0 -39 -24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRise);
export default __webpack_public_path__ + "static/media/rise.27bac40af0112db5b1c141f4ed3104aa.svg";
export { ForwardRef as ReactComponent };